import { render, staticRenderFns } from "./SSelectAgricultural.vue?vue&type=template&id=2062c147"
import script from "./SSelectAgricultural.vue?vue&type=script&lang=js"
export * from "./SSelectAgricultural.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports